import React from "react";
import PolicyAgreementAppError from "./PolicyAgreementAppError";
import ErrorCodes from "./ErrorCodes";

/**
 * Catches errors of component children.
 */
class PolicyAgreementErrorBoundary extends React.Component<React.PropsWithChildren<{}>, { hasError: boolean }> {

  public static getDerivedStateFromError() {
    return { hasError: true };
  }

  constructor(props: Readonly<{}>) {
    super(props);
    this.state = { hasError: false };
  }

  public componentDidCatch(error: any, errorInfo: any) {
    console.log("Failed to display policy agreements", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return <PolicyAgreementAppError errorCode={ErrorCodes.UNEXPECTED_ERROR}/>;
    }

    return this.props.children;
  }
}

export default PolicyAgreementErrorBoundary;
